export const instamojoInfo = {
    fullName:'',
    contactNumber:'',
    email:'',
    tier:'',
    quantity:'',
    
}